<template>
  <div class="post-content-data__video">
    <video-player :url="data" />
  </div>
</template>

<style lang="scss">
.post-content-data__video {
  grid-column-start: 2;
}
</style>

<script>
import Video from '@/components/Video.vue';

export default {
  props: [
    'content',
  ],
  components: {
    'video-player': Video,
  },
  props: ['data'],
};
</script>
